import React, { useMemo, useState } from "react";
import ProgramasNavigation from "../../components/ProgramasNavigation";
import StatsCard from "../../components/StatsCard";
import { ClientesTransVloz, NovosCadastrosVloz } from "../../components/VlozCharts";
import CampanhaPassouGanhou from "../../components/CampanhaPassouGanhou";
import { TopClientesTransacao, TopBandeirasCashback } from "../../components/TopCharts";
import { useVlozData } from "../../hooks/useVlozData";
import { formatMes } from "../../utils/formatters";



const VlozPage = () => {
  const [periodoKey, setPeriodoKey] = useState("mes-atual");

  const {
    vlozSections,
    transVlozSorted,
    novosCadSorted,
    periodoAtual,
    periodoAnterior,
    dadosCampanha,
    dadosCampanha3x,
    itensTopClientes,
    itensTopBandeiras,
    filtrarAte,
    updatedAt,
    isLoading,
    isRefreshing,
  } = useVlozData();

  const corte = periodoKey === "mes-anterior" ? periodoAnterior : periodoAtual;

  const transVlozAtivos = useMemo(() => filtrarAte(transVlozSorted, corte), [transVlozSorted, corte, filtrarAte]);
  const novosCadAtivos  = useMemo(() => filtrarAte(novosCadSorted,  corte), [novosCadSorted,  corte, filtrarAte]);

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <span className="text-[#1A2B49] font-semibold">Carregando...</span>
      </div>
    );
  }

  return (
    <>
        {isRefreshing && (
        <div className="container">
          <div className="w-[130px] flex mt-4 items-center gap-2 bg-[#01054C] rounded-md px-4 py-2 text-xs font-semibold text-[#fff] animate-pulse">
            <span className="rounded-full" />
            Atualizando...
          </div>
        </div>
      )}
      <ProgramasNavigation>
        <StatsCard
          sections={vlozSections}
          sectionId="vloz"
          onActionChange={(_, key) => setPeriodoKey(key)}
        />
      </ProgramasNavigation>
      <div className="container mt-4 flex flex-col gap-4">
        <ClientesTransVloz
          labels={transVlozAtivos.map((e) => formatMes(e.inicioMes))}
          valores={transVlozAtivos.map((e) => e.clientes)}
        />
        <NovosCadastrosVloz
          labels={novosCadAtivos.map((e) => formatMes(e.inicioMes))}
          valores={novosCadAtivos.map((e) => e.quantidade)}
          m12Index={0}
        />
        <CampanhaPassouGanhou {...dadosCampanha} />
        <CampanhaPassouGanhou titulo="CAMPANHA PASSOU GANHOU - 3X SEM JUROS" {...dadosCampanha3x} />
        <div className="flex gap-4">
          <TopClientesTransacao itens={itensTopClientes} />
          <TopBandeirasCashback itens={itensTopBandeiras} />
        </div>
      </div>
      <footer className="py-5 text-center text-[#8D96A8]">
        <p className="text-sm">
          Dados atualizados em <span className="font-bold text-[#091D4A]">{updatedAt}</span>
        </p>
        <p className="text-sm">Atualização uma vez ao dia com referência d-1</p>
      </footer>
    </>
  );
};

export default VlozPage;
